import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "pricing-area ptb-100 bg-gondola" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = {
  key: 0,
  class: "text-center text-white py-5"
}
const _hoisted_4 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_5 = ["data-aos-delay"]
const _hoisted_6 = { class: "pricing-single-item style-two" }
const _hoisted_7 = { class: "ignite d-block" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "amount" }
const _hoisted_10 = { class: "months" }
const _hoisted_11 = { class: "ps-0 list-unstyled pricing-list" }
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = { class: "border-style" }
const _hoisted_14 = { class: "col-lg-12 text-center mt-4 mt-lg-5" }
const _hoisted_15 = { class: "text-silver" }
const _hoisted_16 = {
  class: "pay-dialog",
  style: {"max-width":"400px"}
}
const _hoisted_17 = {
  key: 0,
  class: "auth-pkg-badge"
}
const _hoisted_18 = { class: "auth-tabs" }
const _hoisted_19 = {
  key: 1,
  class: "auth-error"
}
const _hoisted_20 = { class: "auth-field" }
const _hoisted_21 = { class: "auth-field" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "border-style" }
const _hoisted_24 = { class: "auth-field" }
const _hoisted_25 = { class: "auth-field" }
const _hoisted_26 = { class: "auth-field" }
const _hoisted_27 = { class: "auth-field" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "border-style" }
const _hoisted_30 = {
  class: "pay-dialog",
  style: {"max-width":"440px"}
}
const _hoisted_31 = {
  key: 0,
  class: "ctd-plan-badge"
}
const _hoisted_32 = { class: "ctd-contacts" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 2,
  class: "ctd-card-form"
}
const _hoisted_35 = { class: "ctd-kyc-row" }
const _hoisted_36 = { class: "ctd-kyc-field" }
const _hoisted_37 = { class: "ctd-kyc-field" }
const _hoisted_38 = { class: "ctd-kyc-row" }
const _hoisted_39 = { class: "ctd-kyc-field" }
const _hoisted_40 = ["max"]
const _hoisted_41 = { class: "ctd-kyc-field" }
const _hoisted_42 = { class: "ctd-kyc-row" }
const _hoisted_43 = { class: "ctd-kyc-field" }
const _hoisted_44 = ["value"]
const _hoisted_45 = {
  key: 0,
  class: "ctd-kyc-row"
}
const _hoisted_46 = { class: "ctd-kyc-field" }
const _hoisted_47 = ["value"]
const _hoisted_48 = { class: "ctd-kyc-field" }
const _hoisted_49 = {
  key: 1,
  class: "ctd-kyc-err"
}
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[30] || (_cache[30] = _createElementVNode("div", {
        class: "section-title mw-860 m-auto text-center",
        "data-aos": "fade-up",
        "data-aos-duration": "1000",
        "data-aos-delay": "100"
      }, [
        _createElementVNode("span", { class: "top-title" }, "PRICING PLANS"),
        _createElementVNode("h2", { class: "text-white" }, "Our Affordable Pricing Plans")
      ], -1)),
      (_ctx.loadingPackages)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Loading plans... "))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packages, (pkg, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: pkg.id,
                class: _normalizeClass(["col-xl-4 col-md-6", { 'mt-4 mt-xl-0': index !== 0 }]),
                "data-aos": "fade-up",
                "data-aos-duration": "1000",
                "data-aos-delay": 100 * (index + 1)
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(pkg.duration_days) + " Day Access", 1),
                  _createElementVNode("div", {
                    class: "pricing-content bg-mg",
                    style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.pricingBgs[index % _ctx.pricingBgs.length] + ')' })
                  }, [
                    _createElementVNode("img", {
                      src: pkg.image_url || _ctx.pricingImages[index % _ctx.pricingImages.length],
                      alt: pkg.name
                    }, null, 8, _hoisted_8),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(pkg.name), 1),
                      _createElementVNode("h2", null, "$" + _toDisplayString(pkg.price), 1),
                      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "renew" }, "No Auto-renew", -1))
                    ]),
                    _createElementVNode("ul", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((pkg.features || []), (feature, i) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: i,
                          class: "d-flex justify-content-between align-items-center"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(feature), 1),
                          _cache[26] || (_cache[26] = _createElementVNode("i", { class: "ti ti-circle-check" }, null, -1))
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("button", {
                      class: "btn active w-100",
                      disabled: _ctx.checkingOut === pkg.id,
                      onClick: ($event: any) => (_ctx.subscribe(pkg))
                    }, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.checkingOut === pkg.id ? "Opening..." : "Subscribe Now"), 1)
                    ], 8, _hoisted_12)
                  ], 4)
                ])
              ], 10, _hoisted_5))
            }), 128)),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, [
                _cache[28] || (_cache[28] = _createElementVNode("strong", null, "100%", -1)),
                _cache[29] || (_cache[29] = _createTextVNode(" money-back guarantee for your first 24 Hours. ")),
                _createVNode(_component_RouterLink, {
                  to: "/contact-us",
                  class: "read-more style-two text-grey-teal"
                }, {
                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                    _createTextVNode(" Learn More "),
                    _createElementVNode("i", { class: "ti ti-arrow-right" }, null, -1)
                  ])),
                  _: 1
                })
              ])
            ])
          ]))
    ]),
    (_ctx.authModal.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "pay-overlay",
          onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.authModal.open = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              class: "pay-dialog-close-abs",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.authModal.open = false))
            }, "✕"),
            (_ctx.pendingPkg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _cache[31] || (_cache[31] = _createElementVNode("i", { class: "ti ti-package" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.pendingPkg.name) + " — $" + _toDisplayString(_ctx.pendingPkg.price), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                class: _normalizeClass(['auth-tab', { active: _ctx.authModal.tab === 'login' }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.authModal.tab = 'login'))
              }, "Sign In", 2),
              _createElementVNode("button", {
                class: _normalizeClass(['auth-tab', { active: _ctx.authModal.tab === 'register' }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.authModal.tab = 'register'))
              }, "Create Account", 2)
            ]),
            (_ctx.authModal.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.authModal.error), 1))
              : _createCommentVNode("", true),
            (_ctx.authModal.tab === 'login')
              ? (_openBlock(), _createElementBlock("form", {
                  key: 2,
                  onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitAuth && _ctx.submitAuth(...args)), ["prevent"])),
                  class: "auth-form"
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[32] || (_cache[32] = _createElementVNode("label", null, "Email", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.authModal.email) = $event)),
                      type: "email",
                      required: "",
                      autocomplete: "email",
                      placeholder: "you@example.com"
                    }, null, 512), [
                      [_vModelText, _ctx.authModal.email]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[33] || (_cache[33] = _createElementVNode("label", null, "Password", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.authModal.password) = $event)),
                      type: "password",
                      required: "",
                      autocomplete: "current-password",
                      placeholder: "••••••••"
                    }, null, 512), [
                      [_vModelText, _ctx.authModal.password]
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn auth-submit",
                    disabled: _ctx.authModal.loading
                  }, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.authModal.loading ? "Signing in..." : "Sign In & Subscribe"), 1)
                  ], 8, _hoisted_22)
                ], 32))
              : (_openBlock(), _createElementBlock("form", {
                  key: 3,
                  onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitAuth && _ctx.submitAuth(...args)), ["prevent"])),
                  class: "auth-form"
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _cache[34] || (_cache[34] = _createElementVNode("label", null, "Full Name", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.authModal.name) = $event)),
                      type: "text",
                      required: "",
                      autocomplete: "name",
                      placeholder: "John Doe"
                    }, null, 512), [
                      [_vModelText, _ctx.authModal.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _cache[35] || (_cache[35] = _createElementVNode("label", null, "Email", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.authModal.email) = $event)),
                      type: "email",
                      required: "",
                      autocomplete: "email",
                      placeholder: "you@example.com"
                    }, null, 512), [
                      [_vModelText, _ctx.authModal.email]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _cache[36] || (_cache[36] = _createElementVNode("label", null, [
                      _createTextVNode("Phone Number "),
                      _createElementVNode("span", { style: {"color":"#666","font-weight":"400"} }, "(optional)")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.authModal.phone) = $event)),
                      type: "tel",
                      autocomplete: "tel",
                      placeholder: "+1 234 567 8900"
                    }, null, 512), [
                      [_vModelText, _ctx.authModal.phone]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _cache[37] || (_cache[37] = _createElementVNode("label", null, "Password", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.authModal.password) = $event)),
                      type: "password",
                      required: "",
                      autocomplete: "new-password",
                      placeholder: "Min. 8 characters",
                      minlength: "8"
                    }, null, 512), [
                      [_vModelText, _ctx.authModal.password]
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn auth-submit",
                    disabled: _ctx.authModal.loading
                  }, [
                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.authModal.loading ? "Creating account..." : "Create Account & Subscribe"), 1)
                  ], 8, _hoisted_28)
                ], 32))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.contactDialog.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "pay-overlay",
          onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.contactDialog.open = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("button", {
              class: "pay-dialog-close-abs",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.contactDialog.open = false))
            }, "✕"),
            _cache[52] || (_cache[52] = _createElementVNode("div", {
              class: "pay-dialog-icon",
              style: {"background":"rgba(201,14,14,0.15)"}
            }, [
              _createElementVNode("i", {
                class: "ti ti-package",
                style: {"color":"#c90e0e"}
              })
            ], -1)),
            _cache[53] || (_cache[53] = _createElementVNode("h4", { class: "pay-dialog-title" }, "Almost there!", -1)),
            (_ctx.contactDialog.pkg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.contactDialog.pkg.name) + " — $" + _toDisplayString(_ctx.contactDialog.pkg.price), 1))
              : _createCommentVNode("", true),
            _cache[54] || (_cache[54] = _createElementVNode("p", { class: "pay-dialog-desc" }, " Pay instantly via our secure payment link, or reach out to us on WhatsApp and we'll get you set up right away. ", -1)),
            _createElementVNode("div", _hoisted_32, [
              (_ctx.contactDialog.pkg)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "ctd-contact-btn ctd-pay",
                    disabled: _ctx.checkingOut === _ctx.contactDialog.pkg.id,
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.doCheckout(_ctx.contactDialog.pkg)))
                  }, [
                    _cache[38] || (_cache[38] = _createElementVNode("i", { class: "ti ti-wallet" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.checkingOut === _ctx.contactDialog.pkg?.id ? 'Opening...' : 'Pay with Crypto / Wallet'), 1)
                  ], 8, _hoisted_33))
                : _createCommentVNode("", true),
              (_ctx.contactDialog.pkg && !_ctx.contactDialog.showCardForm)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "ctd-contact-btn ctd-card",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.contactDialog.showCardForm = true))
                  }, _cache[39] || (_cache[39] = [
                    _createElementVNode("i", { class: "ti ti-credit-card" }, null, -1),
                    _createTextVNode(" Pay by Card (Visa / Mastercard) ")
                  ])))
                : (_ctx.contactDialog.pkg)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _cache[40] || (_cache[40] = _createElementVNode("label", null, [
                            _createTextVNode("First Name "),
                            _createElementVNode("span", { class: "ctd-req" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.contactDialog.firstName) = $event)),
                            type: "text",
                            autocomplete: "given-name",
                            class: "ctd-kyc-input",
                            placeholder: "John"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.contactDialog.firstName,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _cache[41] || (_cache[41] = _createElementVNode("label", null, [
                            _createTextVNode("Last Name "),
                            _createElementVNode("span", { class: "ctd-req" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.contactDialog.lastName) = $event)),
                            type: "text",
                            autocomplete: "family-name",
                            class: "ctd-kyc-input",
                            placeholder: "Smith"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.contactDialog.lastName,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _cache[42] || (_cache[42] = _createElementVNode("label", null, [
                            _createTextVNode("Date of Birth "),
                            _createElementVNode("span", { class: "ctd-req" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.contactDialog.dob) = $event)),
                            type: "date",
                            max: _ctx.maxDob,
                            class: "ctd-kyc-input"
                          }, null, 8, _hoisted_40), [
                            [_vModelText, _ctx.contactDialog.dob]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _cache[43] || (_cache[43] = _createElementVNode("label", null, [
                            _createTextVNode("Phone "),
                            _createElementVNode("span", { class: "ctd-req" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.contactDialog.phone) = $event)),
                            type: "tel",
                            autocomplete: "tel",
                            class: "ctd-kyc-input",
                            placeholder: "+1 555 123 4567"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.contactDialog.phone,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _cache[45] || (_cache[45] = _createElementVNode("label", null, [
                            _createTextVNode("Country "),
                            _createElementVNode("span", { class: "ctd-req" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.contactDialog.country) = $event)),
                            class: "ctd-kyc-input"
                          }, [
                            _cache[44] || (_cache[44] = _createElementVNode("option", { value: "" }, "Select…", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (c) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: c.code,
                                value: c.code
                              }, _toDisplayString(c.name), 9, _hoisted_44))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.contactDialog.country]
                          ])
                        ])
                      ]),
                      (_ctx.contactDialog.country === 'US')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _cache[47] || (_cache[47] = _createElementVNode("label", null, [
                                _createTextVNode("State "),
                                _createElementVNode("span", { class: "ctd-req" }, "*")
                              ], -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.contactDialog.state) = $event)),
                                class: "ctd-kyc-input"
                              }, [
                                _cache[46] || (_cache[46] = _createElementVNode("option", { value: "" }, "Select…", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usStates, (s) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: s.code,
                                    value: s.code
                                  }, _toDisplayString(s.name), 9, _hoisted_47))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _ctx.contactDialog.state]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _cache[48] || (_cache[48] = _createElementVNode("label", null, [
                                _createTextVNode("ZIP / Postal Code "),
                                _createElementVNode("span", { class: "ctd-req" }, "*")
                              ], -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.contactDialog.postalCode) = $event)),
                                type: "text",
                                inputmode: "numeric",
                                class: "ctd-kyc-input",
                                placeholder: "e.g. 10001"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.contactDialog.postalCode,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _cache[50] || (_cache[50] = _createElementVNode("p", { class: "ctd-kyc-note" }, [
                        _createElementVNode("i", { class: "ti ti-info-circle" }),
                        _createTextVNode(" These details are required by our card processor for secure payment. You must be 18 or older.")
                      ], -1)),
                      (_ctx.contactDialog.cardError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.contactDialog.cardError), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "ctd-contact-btn ctd-card",
                        disabled: _ctx.checkingOut === _ctx.contactDialog.pkg.id,
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.doCheckout(_ctx.contactDialog.pkg, 'card')))
                      }, [
                        _cache[49] || (_cache[49] = _createElementVNode("i", { class: "ti ti-credit-card" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.checkingOut === _ctx.contactDialog.pkg?.id ? 'Opening...' : 'Continue to Card Payment'), 1)
                      ], 8, _hoisted_50)
                    ]))
                  : _createCommentVNode("", true),
              (_ctx.contactInfo.whatsapp_number || _ctx.contactInfo.phone)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 3,
                    href: 'https://wa.me/' + (_ctx.contactInfo.whatsapp_number || _ctx.contactInfo.phone).replace(/\D/g,'') + '?text=' + encodeURIComponent('Hi! I\'d like to subscribe to the ' + (_ctx.contactDialog.pkg?.name || '') + ' plan ($' + (_ctx.contactDialog.pkg?.price || '') + '). Please assist.'),
                    target: "_blank",
                    rel: "noopener",
                    class: "ctd-contact-btn ctd-wa"
                  }, _cache[51] || (_cache[51] = [
                    _createElementVNode("i", { class: "ti ti-brand-whatsapp" }, null, -1),
                    _createTextVNode(" WhatsApp Us ")
                  ]), 8, _hoisted_51))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              class: "pay-dialog-done",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.contactDialog.open = false))
            }, "Close")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}